import { css as e, styled as t } from "styled-components";
//#region src/components/TimePicker/styled/TimeOptionList.styled.ts
var n = t.div`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 176px;
    max-height: 264px;
    overflow-y: auto;
    padding-right: 2px;

    &::-webkit-scrollbar {
        width: 4px;
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-thumb {
        background: ${({ theme: e }) => e.colors.border};
        border-radius: 2px;
    }
`, r = t.button`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1px;
    width: 100%;
    border: none;
    background: ${({ theme: e, $sel: t }) => t ? e.colors.primary : "transparent"};
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    padding: ${({ theme: e }) => e.spacing(.75, 1.5)};
    border-radius: ${({ theme: e }) => e.radii.md};
    text-align: left;
    /* A taken row is still a real target — it answers with the refusal — so the
       cursor must not promise it is inert. */
    cursor: pointer;
    transition: background ${({ theme: e }) => e.transitions.fast};

    ${({ $sel: t, theme: n }) => !t && e`
            &:hover {
                background: ${n.colors.accent};
            }
        `}
`, i = t.span`
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    font-weight: ${({ theme: e, $sel: t }) => t ? e.typographyTokens.weights.semibold : e.typographyTokens.weights.normal};
    color: ${({ theme: e, $sel: t, $taken: n }) => t ? e.colors.primaryForeground : n ? e.colors.mutedForeground : e.colors.foreground};
    text-decoration: ${({ $taken: e }) => e ? "line-through" : "none"};
`, a = t.span`
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.xs};
    color: ${({ theme: e, $sel: t }) => t ? e.colors.primaryForeground : e.colors.mutedForeground};
    opacity: ${({ $sel: e }) => e ? .8 : 1};
`;
//#endregion
export { a as OptionHint, i as OptionLabel, n as OptionList, r as OptionRow };
